import projectImage1 from '../asset/projects/1.jpg';
import projectImage2 from '../asset/projects/2.jpg';
import projectImage3 from '../asset/projects/3.jpg';
import projectImage4 from '../asset/projects/4.jpg';
import projectImage5 from '../asset/projects/5.jpg';
import projectImage6 from '../asset/projects/6.jpg';
import projectImage7 from '../asset/projects/7.jpg';
import projectImage8 from '../asset/projects/8.jpg';

const projectData = [
  {
    id: 1,
    image: projectImage1,
    title: 'World within world',
    status: '|Academic|2024|'
  },
  {
    id: 2,
    image: projectImage2,
    title: 'Between Spaces A social housing',
    status: '|Academic|2023|'
  },
  {
    id: 3,
    image: projectImage3,
    title: 'Settlement study',
    status: '|Academic|2020|'
  },
  {
    id: 4,
    image: projectImage4,
    title: 'Madhuban Homes',
    status: '|Professional|2021|'
  },
  {
    id: 5,
    image: projectImage5,
    title: 'Twisted Apartment',
    status: '|Professional|2023|'
  },
  {
    id: 6,
    image: projectImage6,
    title: 'Lazimpat Apartment',
    status: '|Professional|2022|'
  },
  {
    id: 7,
    image: projectImage7,
    title: 'IVF Interior',
    status: '|Professional|2021|'
  },
  {
    id: 8,
    image: projectImage8,
    title: 'Model',
    status: '|Professional|2019|'
  }
];

export default projectData;
